<div
  #primaryNav
  class="primary"
>
  <div class="items">
    <div class="main-menu">
      @if (
        userState.current()?.permissions?.canAddRequestForRequestForQuotation ||
        userState.current()?.permissions?.canAddProject ||
        userState.current()?.permissions?.canAddRequestForRequestForQutoationFromTemplate
      ) {
        <procure-menu [isExpanded]="sidenavService.isExpanded()">
          <div class="create-action">
            <button
              class="button"
              procure-button
              color="primary"
              [prefix]="sidenavService.isExpanded() ? 'add_circle' : undefined"
              [condensed]="!sidenavService.isExpanded()"
              [condensedIcon]="!sidenavService.isExpanded() ? 'add_circle' : undefined"
              [attr.aria-label]="'Create'"
              [attr.title]="!sidenavService.isExpanded() ? 'Create' : null"
              [matMenuTriggerFor]="createMenu.menu()"
            >
              @if (sidenavService.isExpanded()) {
                Create
              }
            </button>
          </div>
        </procure-menu>
        <procure-create-menu #createMenu />
      }
      <procure-menu
        [isExpanded]="sidenavService.isExpanded()"
        [suppressActive]="hasAsideContent()"
      >
        <procure-menu-item
          icon="home"
          label="Dashboard"
          [link]="['/']"
        />
        <procure-menu-item
          partialMatch
          icon="local_shipping"
          label="Suppliers"
          [link]="['/suppliers']"
        />
        @if (userState.current()?.permissions?.canManageCategories) {
          <procure-menu-item
            partialMatch
            icon="widgets"
            label="Category Management"
            [link]="['/categories']"
          />
        }
        @if (userState.current()?.permissions?.canManageTemplates) {
          <procure-menu-item
            icon="move_down"
            label="Templates"
            [link]="['/templates']"
          />
        }
        @if (userState.current()?.permissions?.canViewProductCatalog) {
          <procure-menu-item
            partialMatch
            icon="inventory_2"
            label="Product Price Database"
            [link]="['/product-catalog']"
          />
        }
      </procure-menu>
    </div>
    <span class="separator"></span>
    <router-outlet
      name="aside"
      (activate)="hasAsideContent.set(true)"
      (deactivate)="hasAsideContent.set(false)"
    />
  </div>
  <procure-resize-handler
    placement="left"
    (mousedown)="startResizing($event)"
  />
  <procure-sidenav-toggle-button
    placement="left"
    [isExpanded]="sidenavService.isExpanded()"
    (click)="toggle()"
  />
</div>
<procure-app-secondary-navigation (activated)="collapsePrimary()" />
